export class User {


    username = '';
    password = '';
    lastlogintime = new Date();
    //rememberme=false;

    constructor(uname: string, passowrd: string, lastlogintime: Date) {
        this.username = uname;
        this.password = passowrd;
        this.lastlogintime = lastlogintime;
        //this.rememberme = keepMeLogin;
    }

}

export class ForgotPassword {


    username = '';
    securityquestion = '';
    securityanswer = '';
    newpassword = '';
    confirmpassword = '';

    constructor(uname: string, npassowrd: string, cpassowrd: string, securityquestion: string, securityanswer: string) {
        this.username = uname;
        this.newpassword = npassowrd;
        this.confirmpassword = cpassowrd;
        this.securityquestion = securityquestion;
        this.securityanswer = securityanswer;
    }

}



export class FirstTimePasswordObj {

    userId = "";
    username = "";
    set_timezone = '';
    timezone: {id: string, code: string, description: string, offset: string};
    password = '';
    lastlogintime = new Date();
    constructor(userId: string, username: string, timezone: any, password: string, lastlogintime: Date, set_timezone: string) {
        this.userId = userId;
        this.username = username;
        this.password = password;
        this.timezone = timezone;
        this.set_timezone = set_timezone;
        this.lastlogintime = lastlogintime;
    }

}
export class ResetPasswordObj {

    passwordResetLink = "";
    username = "";
    timeZoneId='';
    timezone: {id: string, code: string, description: string, offset: string};
    password = '';
    lastlogintime = new Date();
    constructor(passwordResetLink: string, username: string, timezone: any, password: string, lastlogintime: Date, timeZoneId: string) {
        this.passwordResetLink = passwordResetLink;
        this.username = username;
        this.password = password;
        this.timezone = timezone;
        this.timeZoneId = timeZoneId;
        this.lastlogintime = lastlogintime;
    }

}
export class LeadsAdvanceSearch {

    lastName = "";
    userId = "";
    leadNumber = "";
    eventIds:any=[];
    vehicleOfInterestIds:any=[];
    priorityIds = "";
    statusIds:any = [];
    sourceIds :any= [];
    submitionDate : string;
    fromDate : string;
    toDate : string;
    countryIds :any= [];
    vehiclePurposeIds :any= [];
    offset:number=0;
    pageLimit: number;
    isPagination=true;
    orderBy="";
    sortBy="";
    websites:any=[];
    campaignNames:any=[];
    firstName =""
    regionIds:any =[]
    isExact:boolean = false
    constructor(lastName: string, userId: string, leadNumber: string, eventIds: any, vehicleOfInterestIds: any, priorityIds: string, statusIds: any, sourceIds: any, submitionDate:string, countryIds: any, vehiclePurposeIds:any,offset: number, pageLimit: number,fromDate:string,toDate:string,isPagination:boolean,orderBy:string,sortBy:string, websites:any,campaignNames:any, firstName:string,regionIds:any,isExact:boolean) {
        this.lastName = lastName;
        this.userId = userId;
        this.leadNumber = leadNumber;
        this.eventIds = eventIds;
        this.vehicleOfInterestIds = vehicleOfInterestIds;
        this.priorityIds = priorityIds;
        this.statusIds = statusIds;
        this.sourceIds = sourceIds;
        this.submitionDate = submitionDate;
        this.countryIds = countryIds;
        this.vehiclePurposeIds = vehiclePurposeIds;
        this.offset = offset;
        this.pageLimit = pageLimit;
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.isPagination = isPagination;
        this.orderBy = orderBy;
        this.sortBy = sortBy;
        this.websites = websites;
        this.campaignNames = campaignNames;
        this.firstName = firstName
        this.regionIds = regionIds
        this.isExact = isExact
    }
}


export class LeadsForm {
    adobeIdC = "";
    userId = "";
    leadId = "";
    submissionDate = new Date();
    dealerCode="";
    dealerName="";
    individual : {id:number, sugarIndividualKey: string,firstName:string,lastName:string,phone:number,mobile:number,email:string,dateEntered:string,dateModified:string};
    companyName = "";
    currentVehicale : {id:number,make:string,model:string};
    vehicleOfInterest: {id:number,make:string,model:string};
    country = "";
    statusId ="";
    sourceId = "";
    callToAction = "";
    eventId: {eventId:number,eventDescription: string};
    assignTo ="";
    intentionId = "";
    address = "";
    city = "";
     constructor(
       adobeIdC :string,
       userId :string,
    leadId:string,
    submissionDate: Date,
    dealerCode:string,
    dealerName:string,
    individual : any,
    companyName :string,
    currentVehicale :any,
    vehicleOfInterest: any,
    country :string,
    statusId :string,
    sourceId :string,
    callToAction:string,
    eventId: any,
    assignTo:string,
    intentionId:string,
    address : string,
    city : string){

    this.userId =userId;
    this.leadId=leadId;
    this.submissionDate= submissionDate;
    this.dealerCode=dealerCode;
    this.dealerName=dealerName;
    this.individual =individual;
    this.companyName =companyName;
    this.currentVehicale =currentVehicale;
    this.vehicleOfInterest= vehicleOfInterest;
    this.country =country;
    this.statusId =statusId;
    this.sourceId =sourceId;
    this.callToAction=callToAction;
    this.eventId= eventId;
    this.assignTo=assignTo;
    this.intentionId=intentionId;
    this.address = address;
    this.city = city;
    this.adobeIdC = adobeIdC;

     }

}


export class CaseAdvanceSearch {
    userId:any = "";
    searchKey:any="";
    dealerIds:any = [];
    priorityIds:any = [];
    statusIds:any = [];
    caseSourceIds:any = [];
    assignTos:any = [];
    caseNumber:any= "";
    vin:any="";
    fromDate:string;
    toDate:string;
    caseTypeIds:any=[];
    caseOpenDate:string;
    offset:number=0;
    pageLimit:number;
    isPagination=true;
    sortBy="";
    orderBy="";
    firstName ="";
    regionIds:any =[]
    isExact:boolean = false
    constructor(userId: string,searchKey:string, dealerIds: any, priorityIds: any, statusIds: any, caseSourceIds: any, assignTos: any,caseNumber:any,vin:any,fromDate:string,toDate:string,caseTypeIds:any, caseOpenDate: string, offset: number, pageLimit:number,isPagination:boolean,sortBy:string,orderBy:string,firstName:string,regionIds:any,isExact:boolean) {
        this.userId = userId;
        this.searchKey=searchKey;
        this.dealerIds=dealerIds;
        this.priorityIds = priorityIds;
        this.statusIds = statusIds;
        this.caseSourceIds = caseSourceIds;
        this.assignTos=assignTos;
        this.caseNumber=caseNumber;
        this.vin=vin;
        this.fromDate=fromDate;
        this.toDate=toDate;
        this.caseTypeIds = caseTypeIds;
        this.caseOpenDate = caseOpenDate;
        this.offset = offset;
        this.pageLimit = pageLimit;
        this.isPagination = isPagination;
        this.sortBy = sortBy;
        this.orderBy = orderBy;
        this.firstName = firstName;
        this.regionIds = regionIds;
        this.isExact= isExact;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/models/data-model.ts